// ─────────────────────────────────────────────────────────────────────────────
// MIRROR OF backend/constants/marketExpansion.js — where Doorly is LICENSED.
//
// 🚨 IT EXISTS BECAUSE THE PUBLIC PARTNER LANDING PAGE CLAIMED FLORIDA. A stat
// card read "Markets served — TX + FL" as literal text. Doorly holds a Texas
// Mortgage Company license; the Florida license is PENDING. Taking the
// application is itself the licensed activity under Fla. Stat. Ch. 494, so
// presenting Florida as a served market is a licensing representation the
// company cannot make — on the page it recruits partners with.
//
// ⚠️ THE SAME DEFECT THE BACKEND HAD, ONE SURFACE OVER. utils/
// partnerLeadDripCampaign derived its state list from LIVE_STATES — the
// ELIGIBILITY matrix, which contains FL — and told partners Doorly lends there.
// backend/test/licenseClaims.test.js was written for exactly that and did not
// reach the frontend, because there was no frontend constant to check.
//
// 🔑 LICENSED, NOT LIVE. LIVE_STATES answers "is this borrower eligible";
// LICENSED_STATES answers "may Doorly originate here". Any sentence about
// markets, coverage or where Doorly lends is the second question.
//
// ⚠️ LOCKSTEP RULE, same as commissionRates.js and doorlyProgramTerms.js:
// backend/test/frontendMirrors.test.js compares this file against the backend
// one, so the two cannot disagree about where Doorly is licensed.
// ─────────────────────────────────────────────────────────────────────────────

// ⚠️ BOTH SHAPES, BECAUSE BOTH ARE NEEDED AND A CALLER THAT HAS ONLY ONE
// INVENTS THE OTHER. Copy wants "Texas"; a form gate compares against the
// two-letter code the select emits. PreQualification.js typed ['TX','FL']
// because there was nowhere to read a code list from.
export const LICENSED_STATE_CODES = ['TX'];
export const LICENSED_STATES = ['Texas'];

// Named rather than silently omitted. A partner who works Florida deals learns
// nothing from a list that simply lacks it; the in-progress note is the answer.
export const PENDING_LICENSE_STATE_CODES = ['FL'];
export const PENDING_LICENSE_STATES = ['Florida'];

const phrase = (a) => (a.length <= 1 ? (a[0] || '')
  : `${a.slice(0, -1).join(', ')} and ${a[a.length - 1]}`);

/** "Texas" — for a stat card or a short label. */
export const licensedStatesShort = () => phrase(LICENSED_STATES);

/** Renders to '' the day Florida issues, with no further edit here. */
export const pendingLicenseNote = () => (PENDING_LICENSE_STATES.length
  ? `${phrase(PENDING_LICENSE_STATES)} licensing is in progress.`
  : '');

// ── 🔑 THE LICENCE TABLE, MIRRORED ROW FOR ROW (Hannah, 2026-11-03) ─────────
//
// The investor page and the underwriting portal each typed a Texas row and a
// Florida row by hand. Florida was correct (pending) only because somebody
// remembered to edit both pages; the day the status changes, two hand-typed
// tables are two chances to be wrong in front of an investor. They render these
// rows now. backend/test/licensingClaimSource.test.js evaluates this file and
// compares it, field for field, with backend licenseRows().
//
// ⚠️ NO `target` HERE. The backend's Florida target date is admin-only and must
// never reach a rendered page; the mirror test fails if one is added.
export const LICENSES = [
  { code: 'TX', state: 'Texas', type: 'Mortgage Company', status: 'issued', nmls: '2764749' },
  { code: 'FL', state: 'Florida', type: 'Mortgage Broker', status: 'pending', nmls: null },
];

/** "Licensed in Texas. Florida licensure in process." — the pending half drops out by itself. */
export const licenseStatusSentence = () => {
  const issued = `Licensed in ${phrase(LICENSED_STATES)}.`;
  return PENDING_LICENSE_STATES.length
    ? `${issued} ${phrase(PENDING_LICENSE_STATES)} licensure in process.`
    : issued;
};

// ── 🔑 THE LEGAL ENTITY, MIRRORED (Hannah, 2026-11-03) ──────────────────────
// Go Doorly, LLC is a DELAWARE LLC: formed in Delaware, licensed in Texas.
// Held equal to backend COMPANY_ENTITY by test/licensingClaimSource.
export const COMPANY_ENTITY = { name: 'Go Doorly, LLC', formation: 'Delaware', entityType: 'limited liability company' };
/** "Go Doorly, LLC, a Delaware limited liability company". */
export const entityDescription = () => `${COMPANY_ENTITY.name}, a ${COMPANY_ENTITY.formation} ${COMPANY_ENTITY.entityType}`;
